// Copyright © 2017-2019  SDG Systems, LLC. All rights reserved.
// This file may not be used in any form without the express written permission of SDG Systems, LLC

import Vue from 'vue'
import Router from 'vue-router'

import ApiKeyEdit from '@/components/ApiKeyEdit'
import ApiKeys from '@/components/ApiKeys'
import Billing from '@/components/Billing'
import Categories from '@/components/Categories'
import CategoryEdit from '@/components/CategoryEdit'
import Configuration from '@/components/Configuration'
import Index from '@/components/Index'
import ImageList from '@/components/ImageList'
import Image from '@/components/Image'
import Login from '@/components/Login'
import OrganizationEdit from '@/components/OrganizationEdit'
import Organizations from '@/components/Organizations'
import OrgSSOSettingsEdit from '@/components/OrgSSOSettingsEdit'
import PasswordResetConfirm from '@sdgsystems/vue-common/components/PasswordResetConfirm'
import PasswordResetForm from '@sdgsystems/vue-common/components/PasswordResetForm'
import PasswordResetRequest from '@sdgsystems/vue-common/components/PasswordResetRequest'
import QRCode from '@/components/QRCode'
import QRHolder from '@/components/QRHolder'
import Settings from '@/components/Settings'
import Share from '@/components/Share.vue'
import ShareEdit from '@/components/ShareEdit.vue'
import Stats from '@/components/Stats'
import Usage from '@/components/Usage'
import Users from '@/components/Users'
import UserEdit from '@/components/UserEdit'
import UserMe from '@/components/UserMe'
import Webhooks from '@/components/Webhooks'
import WebhookEdit from '@/components/WebhookEdit'
import Public from '@/components/Public.vue'

Vue.use(Router)

Vue.component('qr-holder', QRHolder)

export default new Router({
  routes: [
    {
      path: '/',
      component: Index,
      children: [
        {
          path: '',
          component: ImageList,
          name: 'images'
        },
        {
          path: 'admin/usage',
          name: 'usage',
          component: Usage
        },
        {
          path: 'admin/settings',
          name: 'settings',
          component: Settings
        },
        {
          path: 'apikeys',
          component: ApiKeys,
          name: 'apikeys'
        },
        {
          path: 'apikeys/:id',
          component: ApiKeyEdit,
          name: 'apikeyEdit'
        },
        {
          path: 'config/settings',
          name: 'configSettings',
          component: Configuration
        },
        {
          path: 'config/stats',
          name: 'configStats',
          component: Stats
        },
        {
          path: 'image/:id',
          name: 'imageEdit',
          component: Image
        },
        {
          path: 'categories',
          component: Categories,
          name: 'categories'
        },
        {
          path: 'categories/:id',
          component: CategoryEdit,
          name: 'categoryEdit'
        },
        {
          path: 'organizations',
          component: Organizations,
          name: 'organizations'
        },
        {
          path: 'billing',
          component: Billing,
          name: 'billing'
        },
        {
          path: 'organizations/:id',
          component: OrganizationEdit,
          name: 'organizationEdit'
        },
        {
          path: '/qrcode',
          component: QRCode,
          name: 'qrCode'
        },
        {
          path: 'users',
          component: Users,
          name: 'users'
        },
        {
          path: 'users/:id',
          component: UserEdit,
          name: 'userEdit'
        },
        {
          path: 'userme',
          component: UserMe,
          name: 'userMe'
        },
        {
          path: 'webhooks/:id',
          component: WebhookEdit,
          name: 'webhookEdit'
        },
        {
          path: 'webhooks',
          component: Webhooks,
          name: 'webhooks'
        },
        {
          path: 'ssosettings',
          component: OrgSSOSettingsEdit,
          name: 'ssoSettings'
        },
        {
          path: 'shares',
          component: Share,
          name: 'shares'
        },
        {
          path: 'shares/:id',
          component: ShareEdit,
          name: 'shareEdit'
        }
      ]
    },
    {
      path: '/share/:shareId',
      name: 'public',
      component: Public
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/passwordreset/form',
      component: PasswordResetForm,
      name: 'passwordResetForm'
    },
    {
      path: '/passwordreset/request',
      component: PasswordResetRequest,
      name: 'passwordResetRequest'
    },
    {
      path: '/passwordreset/confirm',
      component: PasswordResetConfirm,
      name: 'passwordResetConfirm'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js